//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import pluralize from 'pluralize'
import products from '../../../common/mixins/products/products'

export default {
  name: 'ListProducts',
  mixins: [products],
  head () {
    return {
      title: this.$getPageTitle(pluralize(this.$capitalize(this.productType)))
    }
  }
}
